<template>

    <div class="welcome-to-origo-component h-100">

        <div class="container h-100">
            <div class="row h-100 align-items-center">
                <div class="col-12">
                    <div class="card">
                        <div class="row">
                            <div class="col-12 col-lg-6 left text-center">

                                <h1 class="text-uppercase">Reset your <span>password</span></h1>

                                <form @submit.prevent="reset" id="login-form">
                                    <div class="input">
                                        <input type="text" class="username" id="username" v-model="payload.body_params.username" autocomplete="off" required>
                                        <label for="username"><i class="icon-profile"></i> Email Address</label>
                                    </div>
                                    <div>
                                        <button type="submit" class="button button--steelBlue w-100">Submit <i class="icon-arrow-right"></i></button>
                                    </div>
                                    <div>
                                        <p>If you don’t know your username – please <a :href="'mailto:'+passwordResetInactiveAccountWarningEmailAddress" aria-label="Contact VLS">contact VLS</a></p>
                                    </div>
                                </form>

                            </div>
                            <div class="col-12 col-lg-6 right text-center">
                                <div class="d-flex flex-column h-100 justify-content-center">
                                    <div>
                                        <i class="logo-icon"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>

</template>

<script>
    import router from '../router';
    import {EventBus} from '@/event-bus.js';

    export default {
        data() {
            return {
                'payload': {
                    'body_params': {
                        'username': '',
                    },
                    'method': 'POST',
                    'endpoint': null,
                    'requiresBearerToken': false,
                },
            };
        },
        computed: {
            username() {
                return this.payload.body_params.username;
            },
            passwordResetInactiveAccountWarningEmailAddress() {
                return this.adminPortalData.content ? this.adminPortalData.content.global.password_reset_inactive_account_warning_email_address : '';
            }
        },
        watch: {
            username() {
                this.payload.endpoint ='users/' + this.payload.body_params.username + '/requestpasswordreset';
            }
        },
        methods: {
            reset() {
                EventBus.$emit('loadingTitle', 'Requesting Password Reset');
                EventBus.$emit('loading', true);

                this.$http.post('/api/reset-password', this.payload)
                .then(response => {
                  // As per pentest just pretend all requests are successful to prevent guessing usernames based on response
                  EventBus.$emit('loading', false);
                  this.$router.push('/request-password-reset-confirmation');
                  /*console.log(response);
                    if (response.data.status == 200) {
                        EventBus.$emit('loading', false);
                        this.$router.push('/request-password-reset-confirmation');
                    } else if (response.data.status === 'error') {
                        EventBus.$emit('loading', false);
                        this.$notify({
                            group: 'notify',
                            type: 'error',
                            title: 'Error',
                            text: response.data.error
                        })
                    }*/
                })
            },
        },
        props: [
            'session',
            'adminPortalData'
        ]
    }
</script>
